import React from "react";
import { QueryRenderer } from "@cubejs-client/react";
import { Spin, Empty } from "antd";
import { Bar } from "react-chartjs-2";
import cubejsApi from "../../../cubejsApiBQ";
import "chartjs-plugin-labels";

const COLORS_SERIES = [
    "#ab7a9e",
    "#4fafaa",
    "#64abd8",
    "#a279c3",
    "#ab7a9e",
    "#4fafaa",
    "#64abd8",
    "#a279c3",
    "#ab7a9e",
    "#4fafaa",
    "#64abd8",
    "#a279c3",
    "#ab7a9e",
    "#4fafaa",
    "#64abd8",
    "#a279c3",
    "#ab7a9e",
    "#4fafaa",
    "#64abd8",
    "#a279c3",
];

const barCarteraCredipoliza = ({ resultSet }) => {
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 1,
    });
    const data = {
        labels: resultSet.categories().map((c) => {
            var category =
                c.category.length > 25 ? c.category.slice(0, 25) : c.category;
            return category;
        }),
        datasets: resultSet.series().map((s) => {
            return {
                label: s.title,
                data: s.series.map((r) => r.value),
                backgroundColor: COLORS_SERIES,
                hoverBackgroundColor: COLORS_SERIES,
            };
        }),
    };
    const options = {
        legend: {
            display: false,
        },
        plugins: {
            labels: {
                fontColor: "#fff",
            },
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    var dataset = data.datasets[tooltipItem.datasetIndex];
                    var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                    var total = meta.total;
                    var currentValue = dataset.data[tooltipItem.index];
                    var percentage = parseFloat(
                        ((currentValue / total) * 100).toFixed(1)
                    );
                    // return formatter.format(currentValue) + " (" + percentage + "%)";
                    return formatter.format(currentValue);
                },
                title: function (tooltipItem, data) {
                    return data.labels[tooltipItem[0].index];
                },
            },
        },
    };
    if (resultSet.categories().length === 0) {
        return <Empty description={<span>No hay datos.</span>} />;
    } else {
        return <Bar data={data} options={options} width={80} height={60} />;
    }
};

const renderChart = (Component) => ({ resultSet, error }) =>
    (resultSet && <Component resultSet={resultSet} />) || <Spin />;

const BarCarteraCredipoliza = (props) => (
    <QueryRenderer
        query={{
            measures: ["ResumenCarteraHistorico.montoCartera"],
            filters: [
                {
                    dimension: "ResumenCarteraHistorico.fechaCorte",
                    operator: "contains",
                    values: props.fecha !== "" ? [props.fecha] : [],
                },
                {
                    dimension: "ResumenCarteraHistorico.zona",
                    operator: "contains",
                    values: props.zona !== "" ? [props.zona] : [],
                },
                {
                    dimension: "ResumenCarteraHistorico.tipoProducto",
                    operator: "contains",
                    values: ["credipoliza"],
                },
            ],
            dimensions: ["ResumenCarteraHistorico.tipoConvenio"],
            segments: [],
        }}
        cubejsApi={cubejsApi}
        render={renderChart(barCarteraCredipoliza)}
    />
);

export default BarCarteraCredipoliza;
